export const stats = [
  { value: '8', label: 'Volumi Completi' },
  { value: '500+', label: 'Pagine di Risorse' },
  { value: '80+', label: 'Unità Didattiche' },
  { value: '100%', label: "Pronto per l'Aula" },
]

export const beforeItems = [
  'Passare le domeniche a pianificare ogni lezione e cercare problemi che funzionino.',
  'Cacciare schede su Pinterest o Google che non sono allineate alle Indicazioni Nazionali.',
  'Nessuna progressione chiara: ti senti sempre al punto di partenza ogni lunedì mattina.',
  'Dover creare da zero test di verifica e griglie per alunni BES/DSA.',
  'Sentirti frustrato perché la burocrazia ti toglie il piacere di spiegare in classe.',
]

export const afterItems = [
  'Un intero anno mappato e organizzato per ogni classe, dalla primaria alle medie.',
  'Lezioni, esercizi e schede pronti per la stampa o la LIM in un click.',
  'Un curriculum a spirale logico: i concetti si costruiscono con solidità anno dopo anno.',
  'Insegnamento passo dopo passo, perfetto anche per supplenti o nuovi docenti.',
  'Verifiche integrate e soluzioni incluse per risparmiare settimane di lavoro.',
]

export const recognizeItems = [
  'Non hai più tempo per creare lezioni che siano davvero coinvolgenti.',
  'Vedi gli studenti annoiarsi o bloccarsi davanti ai soliti esercizi ripetitivi.',
  'Gestire livelli diversi (inclusione) nella stessa classe ti sembra una missione impossibile.',
  'Insegni matematica ma la burocrazia ti sta consumando la passione.',
  'Cerchi un materiale moderno e visuale che funzioni davvero per i ragazzi di oggi.',
]

export type Volume = {
  number: number
  title: string
  text: string
}

export const primaryVolumes: Volume[] = [
  {
    number: 1,
    title: 'Classe 1ª — Numeri e Quantità',
    text: 'Esplorazione del numero, primi calcoli e basi logiche.',
  },
  {
    number: 2,
    title: 'Classe 2ª — Operazioni e Strategie',
    text: 'Tabelline, calcolo in colonna e problemi guidati.',
  },
  {
    number: 3,
    title: 'Classe 3ª — Grandi Numeri e Misure',
    text: "Moltiplicazioni, divisioni e l'introduzione alla geometria.",
  },
  {
    number: 4,
    title: 'Classe 4ª — Frazioni e Decimali',
    text: 'Concetti complessi resi visuali e semplici da capire.',
  },
  {
    number: 5,
    title: 'Classe 5ª — Logica e Geometria',
    text: 'Dati, previsioni e preparazione al salto alle medie.',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    number: 6,
    title: 'Classe 1ª Media',
    text: 'Aritmetica, geometria piana e introduzione al metodo scientifico.',
  },
  {
    number: 7,
    title: 'Classe 2ª Media',
    text: "Rapporti, proporzioni e le basi dell'algebra.",
  },
  {
    number: 8,
    title: 'Classe 3ª Media',
    text: "Equazioni, geometria solida e preparazione completa all'Esame di Stato.",
  },
]

export const bonuses = [
  {
    title: 'Matematica Pronta in 10 Minuti',
    value: '€14,99',
    kicker: 'Guida Setup',
    text: 'Stop al caos. La tabella di marcia per configurare il tuo anno in un lampo.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3ccd05db-f89b-4b99-9323-f88d0733f0de.jpg',
  },
  {
    title: 'Il Caveau del Calcolo Mentale',
    value: '€9,99',
    kicker: '100 Prompt di Riscaldamento',
    text: "Attività rapide per attivare l'attenzione della classe subito.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d8aad0cc-209c-4850-88d5-7a1f68175819.jpg',
  },
  {
    title: 'Ganci Matematici dal Mondo Reale',
    value: '€7,99',
    kicker: '50 Scenari Pronti',
    text: 'Rispondi alla domanda «A cosa serve?» con esempi pratici e reali.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d651612d-839e-40ea-9870-48e977b0f6be.jpg',
  },
  {
    title: 'Matrice di Personalizzazione BES/DSA',
    value: '€5,99',
    kicker: 'Inclusione Immediata',
    text: 'Adatta le tue lezioni in pochi secondi per non lasciare indietro nessuno.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/aaa4a58b-2cf1-424a-86a6-e2f8d310f7e6.jpg',
  },
  {
    title: 'Kit Comunicazione Famiglia e Progressi',
    value: '€4,99',
    kicker: 'Stop al caos comunicativo',
    text: 'Modelli pronti per mostrare ai genitori i risultati concreti.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ef5508aa-ac82-41b7-a2cc-38b0243ad449.jpg',
  },
]

export const offerRows = [
  { label: 'Pack Matematica Pronta (8 Volumi)', value: '€197,00' },
  { label: '5 Bonus Strategici Inclusi', value: '€44,95' },
]

export const testimonials = [
  {
    quote:
      'È esattamente quello di cui avevo bisogno. La programmazione annuale da sola vale il prezzo. Ho finalmente recuperato le mie domeniche.',
    name: 'Sara M.',
    role: 'Insegnante Scuola Primaria',
  },
  {
    quote:
      'Le schede sono bellissime e i ragazzi delle medie non si annoiano. Un materiale di qualità rara in Italia, finalmente qualcosa di moderno.',
    name: 'Giacomo T.',
    role: 'Docente di Matematica',
  },
]

export const faqs = [
  {
    q: 'In che formato sono i materiali?',
    a: 'PDF ad alta risoluzione pronti per stampa o LIM.',
  },
  {
    q: 'È adatto ai supplenti?',
    a: 'Sì, è il «salvavita» ideale per chi cambia spesso classe.',
  },
  {
    q: 'Come ricevo il materiale?',
    a: 'Riceverai un link di download istantaneo subito dopo il pagamento.',
  },
  {
    q: 'Posso usarlo su tablet?',
    a: 'Certamente, è perfetto per essere consultato da qualsiasi dispositivo.',
  },
]

export const heroGuarantees = [
  'Download digitale istantaneo',
  'PDF pronti per la stampa',
  'Pagamento unico',
]

export const footerLinks = ['Termini e Condizioni', 'Privacy Policy', 'Contatti']
